<script setup>
import { onClickOutside, useStorage } from '@vueuse/core'
import xMod from '../common/xMod.vue'
import OrderBook from './orderbook/index.vue'
import MarketTrades from './MarketTrades.vue'

const { t } = useI18n()
const obShow = ref(false)
const ob = useStorage('spot_ob', 0)
const obRef = ref(null)
const tabs = computed(() => [
  {
    title: t('订单表'),
    key: 'orderbook',
    component: OrderBook,
    props: { ob: ob.value },
    show: true,
  },
  {
    title: t('成交记录'),
    key: 'marketTrades',
    component: MarketTrades,
    show: !ob.value,
  },
])
onClickOutside(obRef, () => {
  obShow.value = false
})
</script>

<template>
  <div class="w-[280px] h-[488px] bg-fillPagePrimary">
    <ClientOnly>
      <xMod :tabs="tabs" header-class="h-[30px] text-xs" :is-need-scroll="false" component-class="!px-0" />
    </ClientOnly>
  </div>
</template>
